import React from 'react';
import { Container, Typography } from '@mui/material';

const NotFound = () => {
    return (
        <Container maxWidth="md" sx={{ textAlign: 'center', marginTop: '20px' }}>
            <Typography variant="h4" color="error" gutterBottom>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1">
                The page you are looking for does not exist.
            </Typography>
        </Container>
    );
};

export default NotFound;